module.exports = __webpack_public_path__ + "img/3.61ab9a0d.png";